import styled, { css } from 'styled-components';
import StarBorderIcon from '@material-ui/icons/StarBorder';

export const Text = styled.p`
  text-align: center;
  font-size: 1rem;
  font-weight: bold;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 0.5rem 2rem;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: 0 1rem 2rem;
  }
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  background-color: ${({ theme }) => theme.backgroundHeader};
  color: white;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
`;
export const CenterText = styled.p`
  text-align: center;
  font-size: 1rem;
  font-weight: bold;
  margin: 1rem 0 1rem;
  padding-left: 0.5rem;
`;

export const StyledStarBorderIcon = styled(StarBorderIcon)`
  color: ${({ theme }) => theme.colorSecondary};
`;

export const Content = styled.div`
  display: flex;
  background-color: white;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 1rem;
`;

export const MatchInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
`;

export const StatHelperText = styled.p`
  text-align: center;
  font-weight: bold;
`;

export const HistoryMatchContainer = styled.div<{ shouldHighlight?: boolean; isStatsPass?: boolean; isTeamColumnHide?: boolean; isLate?: boolean }>`
  justify-content: center;
  align-items: center;
  gap: 10px;
  display: grid;
  grid-template-columns: ${({ isTeamColumnHide, isLate }) =>
    isTeamColumnHide ? (isLate ? '80px 150px 110px' : '80px 180px 70px') : '80px 150px 40px 60px'};

  margin: 10px 0.5rem;
  border-radius: 15px;
  box-shadow: rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px;
  font-weight: bold;
  padding: 5px 0;

  ${({ isStatsPass, shouldHighlight }) =>
    shouldHighlight &&
    css`
      background-color: ${isStatsPass ? '#e2f6f1' : '#fbf1e6'};
    `}
`;
export const HeaderHistoryMatchContainer = styled(HistoryMatchContainer)`
  padding: 1rem;
  color: white;
  background: ${({ theme }) => theme.colorMain};
  border-radius: 25px;
  margin: 10px 0;

  ${({ isTeamColumnHide }) =>
    !isTeamColumnHide &&
    css`
      span:nth-child(3) {
        text-align: right;
      }
    `}
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
`;

export const Team = styled.span<{ isHighlighted?: boolean; isFirst?: boolean }>`
  height: ${({ isFirst }) => (isFirst ? '100%' : 'unset')};
  ${({ isHighlighted, theme }) =>
    isHighlighted &&
    `
      color: #4A8E7C;
      font-weight: bold;
    `}
`;

export const StyledScore = styled.span`
  white-space: break-spaces;
`;

export const StyledLateMinutes = styled.span<{ isPassed?: boolean }>`
  color: ${({ isPassed }) => (isPassed ? 'green' : 'black')};

  & + :before {
    display: inline-block;
    content: ', ';
    color: black;
    padding-right: 3px;
  }
`;
